<template>
  <v-container fluid fill-height class="principal-body" style="overflow-y: auto; width: 100%">
    <v-layout align-center column>
      <v-flex fluid class="full-width">
        <h1>
          {{ $t('Help.HELP') }}
        </h1>
      </v-flex><br>
      <v-flex style="text-align: center">
        {{ $t('Help.Forward') }}
        <v-btn style="margin-top: -5px" color="blue lighten-3" x-small @click="goBrowse">
          <v-icon color="white" style="margin-top: -10px; ">
            F
          </v-icon>
        </v-btn>
        {{ $t('Help.when you propose your providers if they want to be paid directly from your clients.') }}
      </v-flex><br>
      <v-flex style="text-align: center">
        {{ $t('Help.Bypay') }}
        <v-btn style="margin-top: -5px" color="blue lighten-3" x-small @click="goBrowse">
          <v-icon color="white" style="margin-top: -10px">
            B
          </v-icon>
        </v-btn>
        {{ $t('Help.when you ask your clients to pay your providers or when you want any client of your client to pay directly') }}
      </v-flex><br>
      <v-flex style="text-align: center">
        {{ $t('Help.If you are owner of a small business or self-employed') }}
      </v-flex><br>
      <v-flex style="text-align: center">
        {{ $t('Help.Bypaying and forwarding invoices saves valuable cash and cash-in time, frees you from bank loans, and enhances your scoring') }}
      </v-flex><br>
      <v-flex style="text-align: center">
        {{ $t('Help.It is way cheaper than banks, safer, faster, and requires no burocracy thanks to the blockchain technology') }}
      </v-flex><br>

      <v-flex style="text-align: center">
        {{ $t('Help.Try it! Byppay') }}
      </v-flex><br>

      <v-flex>
        <v-btn class="black--text" color="secondary" @click="goBrowse">
          <v-icon>
            mdi-undo-variant
          </v-icon>
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
    name: "Help",
    methods: {
        goBrowse () {
            this.$router.push({name: 'NavigationMenu', replace: true});
        }
    }
};
</script>

<style scoped>

</style>
